import React from 'react'
import snapshotJson from "../assets/twentytwentyfive.json"
import Season from "./Season";
import {Snapshot} from "../types";

const Homepage = () => {
    const snapshot = snapshotJson as Snapshot;
    return (
        <Season snapshot={snapshot} />
    )
}

export default Homepage
